import { rem } from 'polished'
import styled from 'styled-components'

export const SortStyled = styled.div`
  font-size: ${rem(16)};
`
